import { TranslateSegmentsResult } from '@ve-pro/api/project/type'
import { Message } from 'element-ui'
import { t } from '@ve-pro/ve/lang'
import _ from 'lodash'
import { TranslateError } from './enums'

const errorTips = [
  {
    value: TranslateError.ErrVideoCreditsNotEnough,
    tips: t('playTurbo.profile.plan.insufficientQuota'),
  },
  {
    value: TranslateError.ErrVoiceEditsNotEnough,
    tips: t('playTurbo.voiceLab.addVoice.disabledTips.voiceEdit'),
  },
  {
    value: TranslateError.ErrVoiceSlotsNotEnough,
    tips: t('playTurbo.voiceLab.addVoice.disabledTips.usedSlot'),
  },
  {
    value: TranslateError.ErrUnknown,
    tips: t('action.someDubbingError'),
  },
]

export function getErrorTips(value: TranslateError) {
  console.log('value', value)
  return errorTips.find((item) => item.value === value)?.tips
}

/**
 * 失败相关提示
 */
export function translateSegmentsResultTips(data: TranslateSegmentsResult) {
  const {
    text_segments,
    video_segments,
    subtitle_segments,
    // combine_segment,
  } = data

  const subtitleRecognitionFailedTips = _.debounce(() => {
    Message.error(t('action.subtitleRecognitionFailed'))
  }, 300)
  // const dubFailedTips = _.debounce(() => {
  //   Message.error(t('action.someDubbingError'))
  // }, 300)
  const translateFailedTips = _.debounce(() => {
    Message.error(t('videoTemplate.detail.table.status.translationFail'))
  }, 300)
  const dubFailedTips = _.debounce((type?: TranslateError) => {
    Message.error(getErrorTips(type ?? TranslateError.ErrUnknown) ?? '')
  }, 300)

  // 失败相关提示
  if (video_segments) {
    Object.values(video_segments).forEach((video_segment) => {
      if (!video_segment.success) {
        subtitleRecognitionFailedTips()
      }

      video_segment.subtitle_segments.forEach((subtitle_segment) => {
        Object.values(subtitle_segment.translate_results).forEach(
          (translate_result) => {
            if (!translate_result.success && translate_result.asset) {
              translateFailedTips()
            }
            if (!translate_result.asset) {
              dubFailedTips(translate_result.error_code)
            }
          },
        )
      })
    })
  }

  if (text_segments) {
    Object.values(text_segments).forEach((text_segment) => {
      Object.values(text_segment).forEach((item) => {
        if (!item.success) {
          translateFailedTips()
        }
      })
    })
  }

  if (subtitle_segments) {
    Object.values(subtitle_segments).forEach((subtitle_segment) => {
      Object.values(subtitle_segment.translate_results).forEach(
        (translate_result) => {
          if (!translate_result.success) {
            translateFailedTips()
          }
        },
      )
    })
  }
}
